export enum ConfigurationCategory {
  'General' = 'GENERAL',
  'Medicare Advantage' = 'MA',
  'Medicare Supplement' = 'MS',
  'Medicare Part D' = 'M_PART_D',
  'Environment' = 'ENVIRONMENT'
}
